// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"ed582fc3","842":"fd75ae27"}[chunkId] + ".chunk.js";
};